import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import { useCheckPermission } from '@/components/hooks/useCheckPermission';
import { useSetHeaderTitle } from '@/components/hooks/useHeaderTitle';
import { useSnackbar } from '@/components/hooks/useSnackbar';
import VadForm, {
  VadData,
  VadPresetError,
} from '@/components/molecules/admin/VadForm';
import { useAddVadPresetMutation } from '@/types/graphql';

const VadAdd = () => {
  const { t } = useTranslation('common');
  useSetHeaderTitle(t('breadcrumb.vad'));

  const permission = useCheckPermission({
    superAdmin: true,
  });

  useCheckPermission({ superAdmin: true });
  const navigate = useNavigate();

  const snackbar = useSnackbar();
  const [addVadPreset, addVadPresetResult] = useAddVadPresetMutation();

  return (
    <VadForm
      loading={addVadPresetResult.loading}
      onSubmit={async (input: VadData) => {
        const result = (
          await addVadPreset({
            variables: {
              input: {
                ...input,
                energyOffset: Number(input.energyOffset),
                ownerCompanyId: permission.ownerCompanyId,
              },
            },
          })
        ).data?.addVadPreset;

        const serverValidationErrors: VadPresetError[] = [];
        if (result?.__typename === 'VadPresetNameAlreadyExists') {
          serverValidationErrors.push({
            type: 'VadPresetNameAlreadyExists',
            message: result.message,
          });
        } else {
          navigate('../');
          snackbar('success', t('message.registered'));
        }

        return serverValidationErrors;
      }}
    />
  );
};
export default VadAdd;
